// extracted by mini-css-extract-plugin
export var dividerContainer = "_8h-0";
export var line = "_8h-1";